import de from "~~/i18n/locales/de.json";
import en from "~~/i18n/locales/en.json";
import fr from "~~/i18n/locales/fr.json";
export default () => ({
	legacy: false,
	locale: "de",
	messages: {
		de,
		en,
		fr
	}
});
